module.exports = "<div seedelement>\n  <div class=\"lui-notification__icon\"><slot name=\"icon\"></slot></div>\n  <div class=\"lui-notification__content\">\n    <div class=\"lui-notification__content-title\"><slot name=\"title\"></slot></div>\n    <slot></slot>\n  </div>\n  <div class=\"lui-notification__bodytext\"><slot name=\"bodytext\"></slot></div>\n  <slot name=\"controls\">\n    <lui-clear></lui-clear>\n  </slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-notification/theme/lui-notification.html
// module id = 264
// module chunks = 0 1 5